//
// PrintFitOption.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var PrintFitOption = {
    NONE:0,
    EXPAND_CLIPPED_CONTENT_IN_APPENDIX:1
};
export default PrintFitOption;
